import React from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  VoicesBufferChannel,
  VoicesPublishingSettings,
} from "../../../Models/voicesProfiles";
import VoicesField from "../Common/VoicesField";
import VoicesInput from "../Common/VoicesInput";
import VoicesTermsInput from "../Common/VoicesTermsInput";
import VoicesChannelSelect from "./VoicesChannelSelect";

interface Props {
  value: VoicesPublishingSettings;
  channelType: "profile" | "page";
  onChange: (
    value: VoicesPublishingSettings,
    channel?: VoicesBufferChannel | null,
  ) => void;
}

const VoicesPublishingFields: React.FC<Props> = ({
  value,
  channelType,
  onChange,
}) => {
  const { t } = useTranslation("voicesProfiles");

  return (
    <Stack spacing={2.5}>
      <VoicesField label={t("bufferChannel")} hint={t("bufferChannelHint")}>
        <VoicesChannelSelect
          value={value.buffer_channel_id}
          channelType={channelType}
          onChange={(channel) =>
            onChange({ ...value, buffer_channel_id: channel?.id ?? null }, channel)
          }
        />
      </VoicesField>

      <VoicesField label={t("weeklyLimit")} hint={t("weeklyLimitHint")}>
        <VoicesInput
          type="number"
          inputProps={{ min: 1 }}
          value={value.weekly_limit ?? ""}
          onChange={(e) =>
            onChange({
              ...value,
              weekly_limit: e.target.value ? Number(e.target.value) : null,
            })
          }
        />
      </VoicesField>

      <VoicesField label={t("blockedTerms")} hint={t("blockedTermsHint")}>
        <VoicesTermsInput
          value={value.blocked_terms}
          onChange={(blocked_terms) => onChange({ ...value, blocked_terms })}
          placeholder={t("blockedTermsPlaceholder")}
        />
      </VoicesField>
    </Stack>
  );
};

export default VoicesPublishingFields;
